import React from 'react'

interface IProps {
  inputJson: any[]
}

const TriggerDescriptionInsta: React.FC<IProps> = ({ inputJson }) => {
  const allIntentIdsArray = inputJson.map((intent) => intent.id)

  return (
    <>
      {allIntentIdsArray.map((intentId) => {
        const selectedIntent = inputJson.find((item) => item.id === intentId)
        const description = selectedIntent?.intentDescription

        return (
          <option key={intentId} value={intentId}>
            {intentId} {description ? ` - ${description}` : ''}
          </option>
        )
      })}
    </>
  )
}

export default TriggerDescriptionInsta
